<section data-testid="impact-card" class="impact-card">
  <header class="impact-card__head">
    <h3 data-testid="impact-title" class="impact-card__title">Impact</h3>
    <p data-testid="impact-subtitle" class="impact-card__subtitle">{{ subtitle }}</p>
  </header>
  <p *ngIf="loading && !impact" data-testid="impact-loading" class="impact-card__muted">Loading…</p>
  <p *ngIf="error" data-testid="impact-error" class="impact-card__error" role="alert">Could not load the impact.</p>
  <p *ngIf="impact && !impact.AsOf" data-testid="impact-no-data" class="impact-card__muted">No nightly insights yet. The impact shows after the first nightly run.</p>
  <dl *ngIf="rows.length" data-testid="impact-dl" class="impact-dl">
    <ng-container *ngFor="let row of rows; trackBy: trackRow">
      <dt class="impact-dl__label" [class.impact-dl__label--sub]="row.sub" [attr.data-testid]="'impact-label-' + row.key">{{ row.label }}</dt>
      <dd class="impact-dl__value" [attr.data-testid]="'impact-row-' + row.key">
        <b class="impact-dl__after" [attr.data-testid]="'impact-after-' + row.key">{{ row.after }}</b>
        <span class="impact-delta" [attr.data-tone]="row.delta.tone" [attr.data-testid]="'impact-delta-' + row.key">{{ row.delta.text }}</span>
      </dd>
    </ng-container>
  </dl>
  <div [hidden]="!tierRows.length" data-testid="impact-tiers" class="impact-tiers">
    <p data-testid="impact-tiers-label" class="impact-tiers__label">Paying companies by health tier</p>
    <div #chart data-testid="impact-tier-chart" class="impact-tiers__chart" role="img"
         aria-label="Health tiers under the saved values and under these values"></div>
    <ul class="impact-tiers__legend">
      <li *ngFor="let tier of tierRows; trackBy: trackRow" class="impact-tiers__item" [attr.data-tier]="tier.key" [attr.data-testid]="'impact-tier-' + tier.key">
        <span class="impact-tiers__name">{{ tier.label }}</span>
        <b class="impact-tiers__count" [attr.data-testid]="'impact-tier-count-' + tier.key">{{ tier.after }}</b>
        <span class="impact-delta" [attr.data-tone]="tier.delta.tone" [attr.data-testid]="'impact-tier-delta-' + tier.key">{{ tier.delta.text }}</span>
      </li>
    </ul>
  </div>
  <div *ngIf="impact?.AsOf && (impact?.AddedTotal || impact?.RemovedTotal)" data-testid="impact-lists" class="impact-lists">
    <div *ngIf="impact?.AddedTotal" data-testid="impact-added" class="impact-list">
      <p data-testid="impact-added-title" class="impact-list__title">{{ addedTitle }}</p>
      <ul class="impact-list__rows">
        <li *ngFor="let company of firstSix(impact?.Added)" data-testid="impact-added-row" class="impact-list__row">
          <span data-testid="impact-list-name" class="impact-list__name">{{ company.companyName }}</span>
          <span data-testid="impact-list-reason" class="impact-list__reason">{{ company.reason }}</span>
        </li>
      </ul>
    </div>
    <div *ngIf="impact?.RemovedTotal" data-testid="impact-removed" class="impact-list">
      <p data-testid="impact-removed-title" class="impact-list__title">{{ removedTitle }}</p>
      <ul class="impact-list__rows">
        <li *ngFor="let company of firstSix(impact?.Removed)" data-testid="impact-removed-row" class="impact-list__row">
          <span data-testid="impact-list-name" class="impact-list__name">{{ company.companyName }}</span>
          <span data-testid="impact-list-reason" class="impact-list__reason">{{ company.reason }}</span>
        </li>
      </ul>
    </div>
  </div>
</section>
